module.exports = __webpack_public_path__ + "img/P2 (1).ea799d99.png";